import { SURVEY_CODE } from '@utils/constants/medicalCodes';
import dayjs from 'dayjs';

const formatSurveyData = (results = [], prefix = '') => {
  if (results.length === 0 || prefix.length === 0) {
    return {};
  }

  const surveyKey = `${prefix}Survey`;
  const surveyTableDataKey = `${prefix}SurveyTableData`;

  return {
    [surveyKey]: results.map((survey) => ({
      [`${prefix}SurveyContent`]: survey?.surveyContent?.item,
    })),
    [surveyTableDataKey]: results
      .slice()
      .reverse()
      .map((survey) => ({
        [`${prefix}SurveyId`]: survey?.surveyId,
        [`${prefix}SurveyScore`]: survey?.score,
        [`${prefix}SurveyDate`]: survey?.createdAt
          ? dayjs(survey?.createdAt).format('MM/DD/YYYY')
          : 'N/A',
      })),
  };
};

const transformSurveyResponsesSearch = (res, httpTransaction, payload) => {
  if (!res || !payload?.code) {
    return {};
  }

  switch (payload?.code) {
    case SURVEY_CODE.QOL_EQ5D5L:
      return formatSurveyData(res?.results, 'qualityOfLife');
    case SURVEY_CODE.MED_ADHERENCE:
      return formatSurveyData(res?.results, 'medAdherence');
    default:
      return {};
  }
};

export default transformSurveyResponsesSearch;
